import React from 'react';
import flag1 from '@/assets/images/flags/i16_SpecialFlag1.png';
import flag2 from '@/assets/images/flags/i16_SpecialFlag2.png';
import flag3 from '@/assets/images/flags/i16_SpecialFlag3.png';
import flag4 from '@/assets/images/flags/i16_SpecialFlag4.png';
import flag5 from '@/assets/images/flags/i16_SpecialFlag5.png';
import flag6 from '@/assets/images/flags/i16_SpecialFlag6.png';
import flag7 from '@/assets/images/flags/i16_SpecialFlag7.png';
import flag8 from '@/assets/images/flags/i16_SpecialFlag8.png';
import flag9 from '@/assets/images/flags/i16_SpecialFlag9.png';
import flag10 from '@/assets/images/flags/i16_SpecialFlag10.png';
import flag11 from '@/assets/images/flags/i16_SpecialFlag11.png';
import flag12 from '@/assets/images/flags/i16_SpecialFlag12.png';
import flag13 from '@/assets/images/flags/i16_SpecialFlag13.png';
import flag14 from '@/assets/images/flags/i16_SpecialFlag14.png';
import flag15 from '@/assets/images/flags/i16_SpecialFlag15.png';
import flag16 from '@/assets/images/flags/i16_SpecialFlag16.png';
import flag17 from '@/assets/images/flags/i16_SpecialFlag17.png';
import flag18 from '@/assets/images/flags/i16_SpecialFlag18.png';
import flag19 from '@/assets/images/flags/i16_SpecialFlag19.png';
import flag20 from '@/assets/images/flags/i16_SpecialFlag20.png';

// Map flag images by SpecialFlag number (1-20)
const flagImages: Record<number, string> = {
  1: flag1,
  2: flag2,
  3: flag3,
  4: flag4,
  5: flag5,
  6: flag6,
  7: flag7,
  8: flag8,
  9: flag9,
  10: flag10,
  11: flag11,
  12: flag12,
  13: flag13,
  14: flag14,
  15: flag15,
  16: flag16,
  17: flag17,
  18: flag18,
  19: flag19,
  20: flag20
};

/**
 * Gets the flag image path based on flag ID
 *
 * Logic:
 * - Extracts the last two digits from the flag ID to determine the flag number
 * - Examples:
 *   - ID 1235420 → last two digits: 20 → SpecialFlag20
 *   - ID 99903 → last two digits: 03 → SpecialFlag3
 *   - ID 1301 → last two digits: 01 → SpecialFlag1
 *
 * @param flagId - The flag ID
 * @returns The path to the flag image, or null if not found
 */
export const getFlagImagePath = (flagId: number | null | undefined): string | null => {
  if (!flagId) return null;

  // Convert flag ID to string to extract last two digits
  const flagIdString = flagId.toString();

  // Extract last two digits
  const lastTwoDigits = flagIdString.slice(-2);

  // Convert to number (handles leading zeros: "03" -> 3, "20" -> 20)
  const specialFlagNumber = parseInt(lastTwoDigits, 10);

  // Only support SpecialFlag1 through SpecialFlag20
  if (isNaN(specialFlagNumber) || specialFlagNumber < 1 || specialFlagNumber > 20) return null;

  return flagImages[specialFlagNumber] ?? null;
};

/**
 * Gets the flag image component for rendering in autocomplete options
 *
 * @param flagId - The flag ID
 * @param includeMargin - Whether to include right margin (default: true for dropdown options)
 * @returns JSX element with the flag image, or null if not found
 */
export const getFlagImage = (flagId: number | null | undefined, includeMargin: boolean = true): React.ReactNode => {
  const imagePath = getFlagImagePath(flagId);
  if (!imagePath) return null;

  return (
    <img
      src={imagePath}
      alt={`Flag ${flagId}`}
      style={{
        width: '16px',
        height: '16px',
        ...(includeMargin && { marginRight: '8px' }),
        objectFit: 'contain'
      }}
    />
  );
};
